module.exports = __webpack_public_path__ + "static/media/Medicine.422e3a6e.svg";